import {
  Pet,
  PetSimulation,
  ResumePetisSimulationProposalClientResponse,
} from '../../../@types/ResumePetisSimulationProposal'
import { useAnimalStore } from '../../../Stores/animalStore'
import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useAnimalValidateStore } from '../../../Stores/useAnimalValidateStore'
import { useCoverageHydration } from '../useCoverageHydration'
import { mountedAnimalSimulation } from './utils/mountedAnimalSimulation'
import { mountedAnimalStandard } from './utils/mountedAnimalStandard'

type AnimalsList = PetSimulation[] | Pet[]

export const useAnimalsHydration = () => {
  const { setNewAnimal } = useAnimalStore()
  const { setIsValid } = useAnimalValidateStore()
  const { handleCoverageHydration } = useCoverageHydration()
  const { setTotalPrice, setTypeOfPrice, setColumnSelected } =
    useSimulatorStore()

  const handleStatesAnimals = (
    animal: PetSimulation,
    animalsList: AnimalsList,
  ) => {
    setIsValid({
      [`questionsAnimal${animal.id}`]: true,
      [`formAnimal${animal.id}`]: true,
    })
    setTotalPrice({
      [`animal-${animal?.id as string}`]: Number(
        animal.pack?.premiums?.[0].premiumsValues?.invoiceRefPremium || 0,
      ),
    })
    setTypeOfPrice(animal.pack?.installment || '')
    handleCoverageHydration(animalsList)
    setColumnSelected(animal.pack?.packId as string)
  }

  const setAnimalsStandard = (animalsStandard: Pet[]) => {
    animalsStandard?.forEach((animal) => {
      setNewAnimal(mountedAnimalStandard(animal))
      handleStatesAnimals(animal, animalsStandard)
    })
  }

  const setAnimalsSimulation = (animalsProposal: PetSimulation[]) => {
    animalsProposal?.forEach((animal) => {
      setNewAnimal(mountedAnimalSimulation(animal))
      handleStatesAnimals(animal, animalsProposal)
    })
  }

  const handleAnimalsHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const isProposal = data.processData?.proposalData
    const isPolicy = data.processData?.policyData
    const proposalOrPolicyData = isProposal || isPolicy

    if (proposalOrPolicyData) {
      setAnimalsStandard(proposalOrPolicyData?.petsList as Pet[])
      setTypeOfPrice(proposalOrPolicyData?.installment || '')
    } else {
      setAnimalsSimulation(
        data.processData?.simulationData?.petsList as PetSimulation[],
      )
    }
  }

  return {
    handleAnimalsHydration,
  }
}
